import { mapActions, mapGetters, mapMutations } from "vuex";
import { validationMixin } from "vuelidate";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import VueFlatPickr from "vue-flatpickr-component";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";

export default {
    name: "personal-data",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                name: "",
                second_name: "",
                last_name: "",
                birthday: "",
                email: "",
                phone: "",
            },
            config: {
                altFormat: "j M, Y",
                dateFormat: "D-M-Y",
                altInput: true,
                locale: Ukrainian,
            },
            validationErrors: {},
        };
    },
    components: {
        "date-picker": VueFlatPickr,
    },
    validations() {
        return {
            payload: {
                name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(30),
                },
                second_name: {
                    minLength: minLength(3),
                    maxLength: maxLength(30),
                },
                last_name: {
                    minLength: minLength(3),
                    maxLength: maxLength(30),
                },
                email: {
                    required,
                    maxLength: maxLength(50),
                    email,
                },
                phone: {
                    required,
                    minLength: minLength(19),
                },
            },
        };
    },
    watch: {},
    computed: {
        ...mapGetters({
            popupRegister: "auth/popupRegister",
            showPersonalData: "auth/showPersonalData",
            user: "profile/user",
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        secondNameErrors() {
            let error = [];
            if (!this.$v.payload.second_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.second_name.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.second_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.second_name) {
                this.validationErrors.second_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastNameErrors() {
            let error = [];
            if (!this.$v.payload.last_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.last_name.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.last_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.last_name) {
                this.validationErrors.last_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired").replace(":name", this.$t("phone")));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    mounted() {
        if (this.user.phone) {
            this.payload.phone = this.user.phone;
        }
        if (this.user.email) {
            this.payload.email = this.user.email;
        }
    },
    methods: {
        ...mapActions({
            updateUserData: `profile/UPDATE_USER_DATA`,
        }),
        ...mapMutations({
            showPopup: `auth/CHANGE_POPUP_PERSONAL_DATA`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let userData = {};
                userData.name = this.payload.name;
                userData.second_name = this.payload.second_name;
                userData.last_name = this.payload.last_name;
                userData.birthday = this.payload.birthday;
                userData.email = this.payload.email;
                userData.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                this.updateUserData(userData)
                    .then(() => {
                        this.$toasted.success(this.$t("successMessageAfterEnterUserData"));
                        this.showPopup(false);
                        this.changePopupRegister({ show: true });
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                        }
                    });
            }
        },
    },
    destroyed() {},
};
